module.exports = __webpack_public_path__ + "static/media/location.a9eae9aa.jpg";